import React from 'react';

import type { PageSegmentLoadStartProps } from '../types/PageSegmentLoadStartProps.ts';

import { UFOSegmentLoadStart } from './UFOSegmentLoadStart.tsx';

/**
 * Component that starts UFO segment load tracking.
 */
export const PageSegmentLoadStart = (props: PageSegmentLoadStartProps) => {
	return <UFOSegmentLoadStart {...props} />;
};
